enum DataTest {
	'data-flow-filter-row' = 'data-flow-filter-row',
	'data-flow-filter-reset' = 'data-flow-filter-reset',
}

export default DataTest;
